const weigthNumber = 10000000000;
export const updateLeagueRankID = (league, isFromUserRegion) => {
    league.defaultOrder = isFromUserRegion ? league.defaultOrder && (league.defaultOrder - weigthNumber) : league.defaultOrder;
    return league;
};
//# sourceMappingURL=updateLeagueRankID.js.map